/**
 * @generated SignedSource<<06bba5a716bbc035bab89cb380be71fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type ShipmentType = "EXTERNALLY_ARRANGED" | "FIRSTDIBS_FACILITATED" | "LOCAL_PICKUP" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type checkoutTransactionReducer_preCheckoutTransaction$data = {
  readonly activeQuote: {
    readonly serviceId: string | null;
  } | null;
  readonly buyer: {
    readonly preferences: {
      readonly currency: Currency | null;
    } | null;
  } | null;
  readonly buyerChargeCurrency: Currency | null;
  readonly currencyConversionRateEvent: {
    readonly serviceId: string | null;
  } | null;
  readonly isAutomatedOffer: boolean | null;
  readonly isPrivateOffer: boolean | null;
  readonly mostRecentOffer: {
    readonly amountPerItem: {
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
    } | null;
    readonly canUseOfferForCheckout: boolean | null;
    readonly priceBookName: string | null;
    readonly quantity: number | null;
  } | null;
  readonly project: {
    readonly name: string | null;
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly shipment: {
    readonly shipmentType: ShipmentType | null;
    readonly shippingAddress: {
      readonly sourceId: string | null;
    } | null;
  } | null;
  readonly skuId: string | null;
  readonly " $fragmentType": "checkoutTransactionReducer_preCheckoutTransaction";
};
export type checkoutTransactionReducer_preCheckoutTransaction$key = {
  readonly " $data"?: checkoutTransactionReducer_preCheckoutTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTransactionReducer_preCheckoutTransaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutTransactionReducer_preCheckoutTransaction"
};

(node as any).hash = "9440425edd7be5e0c974e48afa82b5ba";

export default node;
